import API_URL from "../Api/index";
import { axiosEvent, axiosSchool } from "../Api/axios";

export const getSchool = async () => {
  try {
    const response = await axiosSchool.get('/sekolah-indonesia/24');
    if (response.status === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || "Gagal mengambil data");
    }
  } catch (error) {
    console.error('Gagal mengambil data sekolah:', error);
    return [];
  }
}

export const getValidation = async (selectedCategory, email, phone) => {
  try {
    const formData = new FormData();
    formData.append('type_person', selectedCategory?.value);
    formData.append('email', email);
    formData.append('phone', phone);
    formData.append('id_konten', API_URL.id_event);
    const response = await axiosEvent.post('/appreciationnight/validasi-reg', formData);
    return response;
  } catch (error) {
    console.error('EMAIL atau NOMOR TELEPON tidak terdaftar:', error);
    return [];
  }
}

export const sendRegister = async (postData) => {
  try {
    const response = await axiosEvent.post('/appreciationnight/register', postData);
    return response;
  } catch (error) {
    console.error('Gagal mendaftar evernt!:', error);
    return [];
  }
}